import * as Yup from "yup";

export const partnersValidation = Yup.object().shape({
  clientLogo: Yup.string().required("Partner logo is required"),
});
